import { ref } from 'vue'
import { defineStore } from 'pinia'
import { routes } from '@/router'
import type { MenuItem } from '@/components/menu/menu'

const divider = { type: 'divider' } as const
export const useMenuStore = defineStore('menu', () => {
  const menuItems = ref<MenuItem[]>([])
  const activeMenu = ref<MenuItem | undefined>()
  const is_collapsed = ref<boolean>(false)
  const is_visible = ref<boolean>(true)

  function clear() {
    menuItems.value = []
  }
  function resetMenu() {
    const root = routes[0]
    const route_menu: MenuItem[] = []
    let last_menu
    if (root.children) {
      for (const route of root.children) {
        if (route.meta?.menu) {
          const { menu, guard } = route.meta
          const is_visible = guard ? guard() : true
          if (is_visible) {
            if (menu.separate && (!last_menu || !last_menu.separate)) {
              route_menu.push(divider)
            }
            route_menu.push(menu)
          }
        }
        last_menu = route_menu[route_menu.length - 1]
      }
    }
    menuItems.value = route_menu
  }
  function setActiveMenu(menu: MenuItem | undefined) {
    activeMenu.value = menu
  }
  function toggleVisibility() {
    is_visible.value = !is_visible.value
  }
  function toggleCollapsped() {
    is_collapsed.value = !is_collapsed.value
  }
  function setVisibility(value: boolean) {
    is_visible.value = value
  }
  function setCollapsed(value: boolean) {
    is_collapsed.value = value
  }
  return {
    is_visible,
    is_collapsed,
    toggleVisibility,
    toggleCollapsped,
    setVisibility,
    setCollapsed,
    menuItems,
    clear,
    resetMenu,
    activeMenu,
    setActiveMenu,
  }
})
